import { cn } from "@/lib/cn";

type Props = {
  /** 0–100. Omis = animation indéterminée. */
  progress?: number;
  size?: number;
  label?: string;
  className?: string;
  strokeClassName?: string;
};

export function MailCircularProgress({
  progress,
  size = 52,
  label,
  className,
  strokeClassName = "stroke-[var(--mail-accent)]",
}: Props) {
  const stroke = 4;
  const radius = (size - stroke) / 2;
  const center = size / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped =
    progress === undefined ? undefined : Math.min(100, Math.max(0, progress));
  const dashOffset =
    clamped === undefined
      ? circumference * 0.7
      : circumference - (clamped / 100) * circumference;

  return (
    <div className={cn("flex flex-col items-center gap-1.5", className)}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg
          width={size}
          height={size}
          className={cn(clamped === undefined && "animate-spin")}
          style={clamped === undefined ? { animationDuration: "1.1s" } : undefined}
          aria-hidden
        >
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            className="stroke-[var(--mail-surface-hover)]"
            strokeWidth={stroke}
          />
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            className={cn(strokeClassName, "transition-[stroke-dashoffset] duration-300")}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90 ${center} ${center})`}
          />
        </svg>
        {clamped !== undefined && size >= 32 ? (
          <span
            className="absolute inset-0 flex items-center justify-center text-[10px] font-semibold tabular-nums text-[var(--mail-text)]"
            aria-hidden
          >
            {Math.round(clamped)}%
          </span>
        ) : null}
      </div>
      {label ? (
        <p className="max-w-[12rem] text-center text-[10px] leading-snug text-[var(--mail-muted)]">
          {label}
        </p>
      ) : null}
    </div>
  );
}
